package core.presenter.pages.portfolio

import androidx.compose.material3.Text
import androidx.compose.runtime.Composable

@Composable
fun PortfolioPage(){
    Text("Portfolio")
}